import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailvalidationService {

  constructor(private http: HttpClient) { }

  email_validation(
    email: any,
  ): Observable<any> {

    const params = {
      email: email,
      api_key: "e4b370048d49480c8fc8365dc67d0836",
    }
    return this.http.get('https://emailvalidation.abstractapi.com/v1', { params });
  }

}
